module.exports = __webpack_public_path__ + "static/media/3DPPA28.9b95db2b.jpg";